import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import './i18n';
import * as Sentry from "@sentry/react";

if(import.meta.env.VITE_SENTRY_URL) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_URL,
        _experiments: { enableLogs: true },
    });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
